@if (useIcon) {
    <div class="media">
        <ng-content class="media-object" select="fui-icon"></ng-content>
    </div>
}
@if (useIcon && title) {
    <div class="modal">
        <div class="modal-window">
            <div class="modal-window-content" id="action-label">
                {{ title | translate }}
            </div>
        </div>
    </div>
}
@if (!useIcon) {
    <div class="label">
        <div class="label-title">
            {{ title | translate }}
        </div>
    </div>
}
